import { createSlice, createAsyncThunk } from "@reduxjs/toolkit";
import {
  getBranchInfoAPI,
  getProdcutsSyncStatusAPI,
} from "../../service/api_calls/multiBranchCatalog/multiBranchCatalogAPIs";
import { getHeader, getProductsCount, mapBranchData } from "./reportHelper";
import { getBusinessProductsAPI } from "../../service/api_calls/inventory/InventoryApi";
import { getONDCProductsAPI } from "../../service/api_calls/BusinessPreview/BusinessPreviewAPI";

const initialState = {
  catalogData: null,
  catalogDataLoader: false,
  filterMessage: null,
};

function fetchProductsForAllBranches(branches, masterBranchId) {
  return Promise.all(
    branches?.map(
      (branch) =>
        getProdcutsSyncStatusAPI({
          subBranchId: branch.branchId,
          masterBranchId,
        })
          .then((response) => ({
            branchId: branch.branchId,
            products: response?.details,
          }))
          .catch(() => ({ branchId: branch.branchId, products: [] })) // Handle errors for each branch
    )
  );
}

export const getCatalogReportsData = createAsyncThunk(
  "getCatalogReportsData",
  async (param, thunkAPI) => {
    const branchListData = await getBranchInfoAPI(param?.id);

    const masterBusinessProducts = await getBusinessProductsAPI({
      businessId: param?.id,
    });

    if (branchListData?.details?.branchInfo?.length > 0) {
      const branchProducts = await fetchProductsForAllBranches(
        branchListData?.details?.branchInfo,
        param?.id
      );

      if (branchProducts) {
        console.log("branchListData", branchListData?.details);
        console.log(
          "masterBusinessProducts",
          masterBusinessProducts?.productList
        );
        console.log("branchProducts", branchProducts);
      }

      const header = getHeader(
        param,
        branchListData?.details?.branchInfo,
        branchListData?.details?.branchCount
      );

      const bodyData = mapBranchData(
        masterBusinessProducts?.productList,
        branchProducts
      );

      const productCount = getProductsCount(
        masterBusinessProducts?.productList,
        branchProducts
      );

      console.log("Table Header", header, bodyData, productCount);

      return { header, bodyData, productCount };
    }
  }
);
export const getCatalogReportsFilterData = createAsyncThunk(
  "getCatalogReportsFilterData",
  async (param, thunkAPI) => {
    const branchListData = await getBranchInfoAPI(param?.id);

    const masterBusinessProducts = await getONDCProductsAPI({
      businessId: param.id,
      params: param.params,
    });

    if (branchListData?.details?.branchInfo?.length > 0) {
      const branchProducts = await fetchProductsForAllBranches(
        branchListData?.details?.branchInfo,
        param?.id
      );

      if (branchProducts) {
        console.log("branchListData", branchListData?.details);
        console.log("masterBusinessProducts", masterBusinessProducts);
        console.log("branchProducts", branchProducts);
      }

      const header = getHeader(
        param?.masterBranch,
        branchListData?.details?.branchInfo,
        branchListData?.details?.branchCount
      );

      const bodyData = mapBranchData(masterBusinessProducts, branchProducts);

      const productCount = getProductsCount(
        masterBusinessProducts,
        branchProducts
      );

      const message = `ONDC Category Filter results for “${
        param.selectedOndcCategory
      } - ${param.selectedOndcSubCat}” - ${
        masterBusinessProducts?.length ?? 0
      } products`;

      const category = `${param.selectedOndcCategory} - ${param.selectedOndcSubCat}`;

      console.log("Table Header", header, bodyData, productCount);

      return {
        data: { header, bodyData, productCount },
        filterInfo: { message, category },
      };
    }
  }
);

export const reports = createSlice({
  name: "reports",
  initialState,
  reducers: {},
  extraReducers: {
    [getCatalogReportsData.pending]: (state) => {
      state.catalogDataLoader = true;
      state.catalogData = null;
      state.filterMessage = null;
    },
    [getCatalogReportsData.fulfilled]: (state, { payload }) => {
      state.catalogData = payload;
      state.catalogDataLoader = false;
    },
    [getCatalogReportsData.rejected]: (state, { payload }) => {
      state.catalogDataLoader = false;
      state.catalogData = null;
    },

    [getCatalogReportsFilterData.pending]: (state) => {
      state.catalogDataLoader = true;
      state.catalogData = null;
      state.filterMessage = null;
    },
    [getCatalogReportsFilterData.fulfilled]: (state, { payload }) => {
      state.catalogData = payload.data;
      state.catalogDataLoader = false;
      state.filterMessage = payload.filterInfo;
    },
    [getCatalogReportsFilterData.rejected]: (state, { payload }) => {
      state.catalogDataLoader = false;
      state.catalogData = null;
    },
  },
});

export const reportsReducer = reports.reducer;
